import { IResult } from '../../ts/ServerApi/types/IResponse';
import { IScheduleDetails } from '../../schedule/types/ISchedule';
import { Request } from '../../ts/ServerApi/requests/Request';

// Keep this interface in-sync with ISchedule
export interface IUpdateScheduleParams {
  id: string;
  name: string;
  scheduleType: string; // Hourly, Daily, Weekly, Monthly
  scheduleDetails: IScheduleDetails;
  priority: number;
  parallel: boolean;
}

export class UpdateScheduleRequest extends Request<IUpdateScheduleParams, IResult> {
  constructor(params: IUpdateScheduleParams) {
    super('updateSchedule', params);
  }
}
